import PropTypes from 'prop-types'
import React from 'react'

import Button from '../../../../sitewide/Button'

import styles from './autoBookingPopover.css'

const DeleteConfirmation = ({
  mainMessage,
  onDeleteClick,
  onDeleteConfirm,
  secondaryMessage,
}) => {
  return (
    <div>
      <h1 className={styles.mainMessage}>{mainMessage}</h1>
      <div>
        <Button
          buttonClass={'delete'}
          paddingTB={'8px'}
          paddingLR={'30px'}
          onClick={() => {
            onDeleteClick()
          }}>
          yes
        </Button>
        <Button
          buttonClass={'submit'}
          paddingTB={'8px'}
          paddingLR={'30px'}
          onClick={onDeleteConfirm}>
          no
        </Button>
      </div>
      <h2 className={styles.secondaryMessage}>{secondaryMessage}</h2>
    </div>
  )
}

DeleteConfirmation.propTypes = {
  mainMessage: PropTypes.string.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onDeleteConfirm: PropTypes.func.isRequired,
  secondaryMessage: PropTypes.string.isRequired,
}

export default DeleteConfirmation



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/AutoBookingPopover/DeleteConfirmation.js